export const GRN_STATUS = [
  { label: 'Draft', value: 'draft' },
  { label: 'Pending', value: 'pending' },
  { label: 'Approved', value: 'approved' },
  { label: 'Completed', value: 'completed' },
];

export const getGrnBadgeColor = status => {
  switch (status) {
    case 'draft':
      return 'light';

    case 'pending':
      return 'warning';

    case 'approved':
      return 'success';

    case 'completed':
      return 'primary';

    default:
      return 'light';
  }
};
